export default __webpack_public_path__ + "static/media/unavailableIcon.3cc58f8a.svg";